// The Pages Function uses { code, msg, data }; preserve flat legacy payloads.
export function unwrapIamAdminPayload(payload) {
  if (payload?.code === 0 && payload.data && typeof payload.data === 'object') {
    return payload.data
  }
  return payload
}
